// extracted by mini-css-extract-plugin
var _1 = "EditorShell_active__c2b87";
var _2 = "EditorShell_comments__2dda1";
var _3 = "EditorShell_disableClicks__bae14";
var _4 = "EditorShell_fillMode__74581";
var _5 = "EditorShell_highlighter__4ea52";
var _6 = "EditorShell_noClick__82149";
var _7 = "EditorShell_shell__add3f";
var _8 = "EditorShell_wrapper__d7480";
var _9 = "EditorShell_zeroLineHeight__b034f";
export { _1 as "active", _2 as "comments", _3 as "disableClicks", _4 as "fillMode", _5 as "highlighter", _6 as "noClick", _7 as "shell", _8 as "wrapper", _9 as "zeroLineHeight" }
